// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#gold-points-section .banner[data-v-79ab8e6d]{width:100%;margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
